// -*-mode: rjsx -*-
import React from "react";
import AppContext from "./AppContext.js"

import { makeStyles } from '@material-ui/core/styles';


// LOGGING SETUP
import appConfig from "./App.config.js"
const log = appConfig.getLogger("<LoadTest>")

const useStyles = makeStyles(theme => ({
    root: {
        display: "none",
        color: "white",
        background: "black",
    }
}))

const LoadTest = props => {

    const classes = useStyles()
    const appContext = React.useContext(AppContext)

    log.trace("appContext = ", appContext)

    React.useEffect(() => {
        // we can still precheck it here, even if preload does check itself
        //if(!appContext.jsons["USCD-unzipped"]) {
        //    log.trace("Load additional USCD-unzipped...")
        //    appContext.preload(["USCD-unzipped"])
        //}
        // WORKS, but commented out for performance
        //appContext.preload(["USCD-unzipped"])
        //appContext.preload(["unexisting"])
    })
    
    //log.trace("Ask to load additional USCD-unzipped...")
    //appContext.preload(["USCD-unzipped"])

        
    if(appContext.jsons["NATIONAL"] && !appContext.jsons["NATIONAL"].isLoading) {
        log.trace("NATIONAL ready")
    }

    if(appContext.jsons["STATE"] && !appContext.jsons["STATE"].isLoading) {
        log.trace("STATE ready")
    }

    if(appContext.jsons["USCD"] && !appContext.jsons["USCD"].isLoading) {
        log.trace("USCD ready")
    }

    if(appContext.jsons["USCD-unzipped"] && !appContext.jsons["USCD-unzipped"].isLoading) {
        log.trace("USCD-unzipped ready")
    }


    const UscdUnzippedJson = appContext.getJson("USCD-unzipped")
    if(UscdUnzippedJson) {
        log.trace("can USCD-unzipped json =", UscdUnzippedJson)
    } else {
        log.trace("can't access USCD-unzipped json =", UscdUnzippedJson)
    }

    const NationalJson = appContext.getJson("NATIONAL")
    if(NationalJson) {
        log.trace("can access NATIONAL json =", NationalJson)
    } else {
        log.trace("can't access USCD-unzipped json =", NationalJson)
    }
    
    return (
        <div className={classes.root}>
          <div>LoadTest</div>
          {appContext.jsons["NATIONAL"] && !appContext.jsons["NATIONAL"].isLoading &&
           <div>NATIONAL ready</div>
          }
          {appContext.jsons["STATE"] && !appContext.jsons["STATE"].isLoading &&
           <div>STATE ready</div>
          }
          {appContext.jsons["USCD"] && !appContext.jsons["USCD"].isLoading &&
           <div>USCD ready</div>
          }
          {appContext.jsons["USCD-unzipped"] && !appContext.jsons["USCD-unzipped"].isLoading &&
           <div>USCD-unzipped ready</div>
          }
        </div>
    )

}



export default LoadTest
